import { PrimitiveValueObject } from '@/domain/primitiveValueObject';

export class IsSent extends PrimitiveValueObject<boolean> {
  /**
   * 生成する
   * @param value 値
   * @returns 値オブジェクト
   */
  static create(value: boolean): IsSent {
    return new IsSent(value);
  }
}
